/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React from 'react';

import dates from './utils/dates';
import { navigate } from './utils/constants';
import TimeGrid from './TimeGrid';

class Day extends React.Component {
    static propTypes = {
        date: PropTypes.instanceOf(Date).isRequired,
    };

    render() {
        const { date, ...props } = this.props;
        const range = Day.range(date);

        return <TimeGrid {...props} range={range} eventOffset={10} />;
    }
}

Day.range = date => [dates.startOf(date, 'day')];

Day.navigate = (date, action) => {
    switch (action) {
        case navigate.PREVIOUS:
            return dates.add(date, -1, 'day');

        case navigate.NEXT:
            return dates.add(date, 1, 'day');

        default:
            return date;
    }
};

Day.title = (date, { localizer }) => localizer.format(date, 'dayHeaderFormat');

export default Day;
